/*
 * Authors: mariushirjanu
 * Created: 10/01/2024
 */
import * as _ from 'underscore';
import { Component, Input, SimpleChanges, OnChanges, ViewEncapsulation, Type } from '@angular/core';
import { FormattingService } from '../services/formatting.service';
import { IObject } from '../../../type_definitions/datatypes';

@Component({
  selector: 'search-results',
  template: `
    <div class="search-results">
      <h2 *ngIf="!results.length && (searching || searchingMore)">
        <activity-indicator text="GA.GENERAL.SEARCHING"></activity-indicator>
      </h2>
      
      <div *ngIf="!searching && !searchingMore && results?.length">
        <table class="table search-results-table">
          <tbody>
            <ng-container *ngFor="let result of results; index as i; trackById">
              <tr [ngClass]="{'odd': i%2}">
                <td class="result-collapse-link">
                  <collapse-indicator class="collapse-indicator" [linkName]="getLinkName(result)" [clickable]="true" [open]="result.expanded" (onChange)="onChangeCollapsed(result)"></collapse-indicator>
                </td>
                <td class="d-none d-sm-block">{{ result.id }}</td>
                <td class="result-eta-date">ETA {{ result.etaDate }}</td>
                <td>{{ result.status }}</td>
                <td class="d-none d-sm-block">{{ result.webshop }}</td>
                <td>{{ result.country }}</td>
              </tr>
              <tr [ngClass]="{'odd': i%2}">
                <td colspan="6">
                  <collapsible-pane class="pane-detail" [collapsed]="!result.expanded" *ngIf="result.expanded">
                    <ndc-dynamic [ndcDynamicComponent]="resultDetailComponent" [ndcDynamicInputs]="{ orderId: result.id, hideLinks: result.hideLinks }"></ndc-dynamic>
                  </collapsible-pane>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
  
      <h2 *ngIf="results.length && searchingMore">
        <activity-indicator text="Searching more results"></activity-indicator>
      </h2>
    </div>

  <div *ngIf="query && !searching && !searchingMore && !results?.length">
    <!-- get content projection: no-results -->
    <ng-content select=".no-results"></ng-content>
  </div>
  `,
  styleUrls: ['./search-results.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchResultComponent implements OnChanges {
  @Input() public query:string;
  @Input() public searching:boolean;
  @Input() public searchingMore:boolean;
  @Input() public results:IObject[];
  @Input() public hideLinks:boolean;
  @Input() public resultDetailComponent:Type<any>;
  public collapsed:boolean;

  constructor(
    private formattingService:FormattingService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.query) {
      this.query = _.clone(changes.query.currentValue);
    }
    if (changes.results) {
      this.results = _.clone(changes.results.currentValue);
    }
    if (changes.searching) {
      this.searching = changes.searching.currentValue;
    }
    if (changes.searchingMore) {
      this.searchingMore = changes.searchingMore.currentValue;
    }
    if (changes.hideLinks) {
      this.hideLinks = changes.hideLinks.currentValue;
    }
  }
  
  public onChangeCollapsed(result:IObject):void{
    result.expanded = !result.expanded;
  }

  public getLinkName(searchResult:IObject):string {
    const name:string = this.formattingService.join(searchResult.customerReference, searchResult.poNumber, ' / ');
    return name || searchResult.id;
  }
}
